/**
 * Wrapper Icon Button for the design library button to pass our router specific link
 */

import type { ExoticComponent } from 'react';
import { Link } from 'react-router-dom';
import { IconButton as DesignLibraryIconButton } from '@mweb/zappos-ui/IconButton';
import type { IconButtonProps, IconButtonVariant } from '@mweb/zappos-ui/IconButton';

import { cn } from 'helpers/classnames';

const rebrandIconButtonClasses: Record<IconButtonVariant, string> = {
  filled: 'lumon:bg-gray-900 lumon:hover:bg-gray-700',
  outlined: 'lumon:text-gray-900 lumon:hover:text-gray-700 lumon:hover:border-gray-700',
  filledModerate: 'lumon:text-gray-900 lumon:hover:bg-gray-200',
  outlinedLight: 'lumon:text-gray-0 lumon:hover:text-gray-100 lumon:hover:border-gray-100',
  icon: 'text-gray-900 lumon:hover:text-gray-600'
} as const;

const IconButton = ({ className, href, variant, ...rest }: Omit<IconButtonProps, 'linkComponent' | 'linkProps'>) => (
  <DesignLibraryIconButton
    {...rest}
    className={cn(className, rebrandIconButtonClasses[variant])}
    href={href}
    linkComponent={Link as ExoticComponent}
    linkProps={{ to: href }}
    variant={variant}
  />
);

export default IconButton;
